/**
 * @generated SignedSource<<47efc4395c61efe14828dad319c5cade>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type FastCrawlLoader_flowState$data = {
  readonly id: string;
  readonly flowKey: string | null;
  readonly current: {
    readonly state: string | null;
    readonly percentComplete: number | null;
    readonly errorMessage: string | null;
  } | null;
  readonly pending: {
    readonly state: string | null;
    readonly percentComplete: number | null;
    readonly errorMessage: string | null;
  } | null;
  readonly " $fragmentType": "FastCrawlLoader_flowState";
};
export type FastCrawlLoader_flowState$key = {
  readonly " $data"?: FastCrawlLoader_flowState$data;
  readonly " $fragmentSpreads": FragmentRefs<"FastCrawlLoader_flowState">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "state",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "percentComplete",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "errorMessage",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "FastCrawlLoader_flowState",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "flowKey",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "FlowStatus",
      "kind": "LinkedField",
      "name": "current",
      "plural": false,
      "selections": (v0/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "FlowStatus",
      "kind": "LinkedField",
      "name": "pending",
      "plural": false,
      "selections": (v0/*: any*/),
      "storageKey": null
    }
  ],
  "type": "FlowState",
  "abstractKey": null
};
})();

(node as any).hash = "71033616226c69912f668f83dbb7aaba";

export default node;
